import { intersection } from "lodash";
import { loggedUser } from "../actions/auth.action";

export enum AdminPermission {
  // admin level
  "supervisor" = "supervisor",

  // company
  "company_write" = "company_write",
  "company_read" = "company_read",
  "company_delete" = "company_delete",

  "company_user_write" = "company_user_write",
  "company_user_read" = "company_user_read",
  "company_user_delete" = "company_user_delete",

  "company_store_write" = "company_store_write",
  "company_store_read" = "company_store_read",
  "company_store_delete" = "company_store_delete",

  "customer_write" = "customer_write",
  "customer_read" = "customer_read",
  "customer_delete" = "customer_delete",

  "admin_write" = "admin_write",
  "admin_read" = "admin_read",
  "admin_delete" = "admin_delete",

  "role_write" = "role_write",
  "role_read" = "role_read",
  "role_delete" = "role_delete",

  // data
  "survey_write" = "survey_write",
  "survey_read" = "survey_read",
  "survey_delete" = "survey_delete",

  "question_write" = "question_write",
  "question_read" = "question_read",
  "question_delete" = "question_delete",

  "survey_event_write" = "survey_event_write",
  "survey_event_read" = "survey_event_read",
  "survey_event_delete" = "survey_event_delete",

  "coupon_write" = "coupon_write",
  "coupon_read" = "coupon_read",
  "coupon_delete" = "coupon_delete",
}

export const default_route_map: any = {};
default_route_map[AdminPermission.admin_read] = "admin";
default_route_map[AdminPermission.company_read] = "company";
default_route_map[AdminPermission.role_read] = "role";

export function checkIfHasPermission(permissions?: AdminPermission[]) {
  return (
    loggedUser?.role === AdminPermission.supervisor ||
    (permissions || []).length === 0 ||
    intersection(permissions, loggedUser?.permissions || []).length > 0
  );
}
